<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar />
      </div>
      <div class="flex-fill overflow-auto text-center px-5 py-10">
        <div>
          <h4
            class="font-weight-regular text-center mb-2"
            v-html="calificationConfig.viewTitle"
          ></h4>
        </div>
        <div
          v-if="!calificationConfig.requireRating"
          class="mb-2"
        >
          <v-btn
            class="font-weight-bold mb-2"
            type="button"
            rounded
            block
            text
            :loading="button.calificate.loading"
            :disabled="button.calificate.disabled"
            @click="calificate(false)"
            color="primary"
          >
            {{ calificationConfig.btnWithoutRate }}
          </v-btn>
        </div>
        <div
          id="cammer-detail"
          class="mb-6"
        >
          <v-avatar
            size="100"
            class="border mt-5 mb-4"
            v-if="cammer.profile_image"
          >
            <v-img
              :src="cammer.profile_image"
              alt="John"
            ></v-img>
          </v-avatar>
          <h4
            v-if="cammer.name"
            class="font-weight-regular"
          >
            {{ cammer.name }}
          </h4>
          <p
            v-if="cammer.specialty"
            class="text--secondary"
          >
            <small>{{ cammer.specialty.name }}</small>
          </p>
        </div>
        <h5
          v-if="calificationConfig.subtitle"
          class="px-5 my-4 text-center font-weight-regular text--secondary"
        >
          {{ calificationConfig.subtitle }}
        </h5>
        <v-sheet>
          <v-rating
            v-if="calificationConfig.style === 'numbers'"
            color="primary"
            hover
            length="1"
            v-model="rating"
            class="slider"
          >
            <template v-slot:item="props">
              <a
                v-for="(item, i) in slider.numbers"
                :key="`number-${i}`"
                @click="selectNumber(item)"
                style="padding: 0px 6px; cursor: pointer"
                :style="{
                  fontSize: 15 + 'px',
                  backgroundColor: calificationConfig.colorPalette.isActive ? degrade[i] : 'white',
                }"
                :class="{ 'text--white': calificationConfig.colorPalette.isActive }"
                class="text-box"
              >
                <span :style="props.value >= item ? 'font-size: 15px' : 'color: #BDBDBD'">
                  <span
                    :style="props.value == item ? 'font-size: 22px' : ''">
                      {{item}}
                  </span>
                </span>
              </a>
            </template>
          </v-rating>
          <v-rating
            v-else
            color="primary"
            hover
            :length="1"
            v-model="rating"
          >
            <template
              v-slot:item="props">
              <i
                v-for="(item, i) in slider.numbers"
                :key="`icon-${i}`"
                @click="selectNumber(item)"
                class="pa-0 mr-1"
              >
                <Icon
                  :width="22"
                  :height="22"
                  :color="props.value >= item ? 'primary' : '#BDBDBD'"
                  :icon="calificationConfig.style"
                />
              </i>
            </template>
          </v-rating>
          <v-slider
            v-model="rating"
            color="primary"
            :min="slider.min"
            :max="slider.max"
            :step="slider.steps"
            :hide-details="true"
          ></v-slider>
        </v-sheet>
        <v-label>
          <font size="2">
            {{ calificationConfig.instructionText }}
          </font>
        </v-label>
        <div class="mt-5">
          <v-textarea
            persistent-placeholder
            class="mb-4"
            v-model="comment"
            :label="calificationConfig.label"
            :placeholder="calificationConfig.placeholder"
            dense
            outlined
            rows="3"
            hide-details
          ></v-textarea>
        </div>
        <div
          v-if="calificationConfig.settings.form.isActive"
        >
          <section id="loader" class="pa-5 text-center" v-if="questionnaire.loading">
            <Loader />
          </section>
          <WidgetForm
            v-else-if="questionnaire.item"
            :data="questionnaire.item"
            class="mx-auto"
            style="max-width: 1000px;"
            :questionnaireCode="questionnaireCodeProp"
            @onSuccess="onWidgetFormSuccess"
            @onError="onWidgetFormError"
            ref="myForm"
          >
            <v-btn
              v-if="btnPrimaryConfig.data"
              class="font-weight-bold"
              block
              elevation="0"
              :color="btnPrimaryConfig.data.btn"
              :style="`color: ${btnPrimaryConfig.data.text}`"
              :loading="button.calificate.loading"
              :disabled="button.calificate.disabled"
              type="submit"
            >
              {{ calificationConfig.btnText }}
            </v-btn>
          </WidgetForm>
        </div>
      </div>
      <div
      class="actions px-5 my-2">
        <v-btn
          v-if="btnPrimaryConfig.data && !calificationConfig.settings.form.isActive"
          class="font-weight-bold"
          type="submit"
          block
          elevation="0"
          :color="btnPrimaryConfig.data.btn"
          :style="`color: ${btnPrimaryConfig.data.text}`"
          :loading="button.calificate.loading"
          :disabled="button.calificate.disabled"
          @click="calificate(true)"
        >
          {{ calificationConfig.btnText }}
        </v-btn>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import questionnaireServices from '@/services/Questionnary'
import { mapState } from 'vuex'

import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'
import WidgetPlugin from '@/plugins/Widget'
import interpolateColors from '@/utils/interpolate-colors.utils'

require('@/services/Questionnary')
@Component({
  components: {
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    WidgetForm: () => import('@/components/elements/widget-form/Index.vue'),
    Loader: () => import('@/components/ui/Loader.vue'),
  },
  methods: {
    onWidgetFormSuccess () {
      this.calificate(true)
    },
    onWidgetFormError () {
      this.toggleButton()
    }
  },
  computed: {
    ...mapState({
      questionnaire: state => state.questionnary
    }),
    questionnaireCodeProp () {
      return this.$store.state.storage.form.code
    },
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    calificationConfig () {
      const config = this.$organization.calificationConfig()

      return {
        viewTitle: config?.data?.viewTitle ?? config.defaultData.viewTitle,
        subtitle: config?.data?.subtitle ?? config.defaultData.subtitle,
        label: config?.data?.label ?? config.defaultData.label,
        placeholder: config?.data?.placeholder ?? config.defaultData.placeholder,
        btnText: config?.data?.btnText ?? config.defaultData.btnText,
        style: config?.data?.style ?? config.defaultData.style,
        requireRating: config?.data?.requireRating ?? config.defaultData.requireRating,
        btnWithoutRate: config?.data?.btnWithoutRate ?? config.defaultData.btnWithoutRate,
        instructionText: config?.data?.instructionText ?? config.defaultData.instructionText,
        initialRating: config?.data?.initialRating ?? config.defaultData.initialRating,
        colorPalette: {
          isActive: config?.data?.colorPalette?.isActive ?? config.defaultData.colorPalette.isActive,
          initColor: config?.data?.colorPalette?.initColor ?? config.defaultData.colorPalette.initColor,
          endColor: config?.data?.colorPalette?.endColor ?? config.defaultData.colorPalette.endColor
        },
        settings: config?.data?.settings ?? config?.defaultData?.settings
      }
    },
    cammer () {
      return this.$store.state.storage.room.cammer.user
    },
    ratingSettings () {
      return WidgetPlugin.getOrganizationSettings().rating
    },
    slider () {
      const min = this.ratingSettings.start
      const max = this.ratingSettings.limit
      const steps = 1
      const items = Math.abs(max - min) + 1

      const numbers = () => {
        const numbers = []
        for (let i = min; i <= max; i++) {
          numbers.push(i)
        }
        return numbers
      }

      return { min, max, steps, items, numbers: numbers() }
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      degrade: [],
      rating: 0,
      comment: '',
      recommend: true,
      button: {
        calificate: {
          loading: false,
          disabled: false
        }
      }
    }
  }

  selectNumber (data){
    this.rating = data
  }

  generateColor () {
    const initColor = this.calificationConfig.colorPalette.initColor
    const endColor =  this.calificationConfig.colorPalette.endColor

    return interpolateColors(initColor, endColor, this.slider.items)
  }

  mounted () {
    this.ocGoogleAnalyticsInit()

    if (this.calificationConfig.settings.form.isActive) {
      questionnaireServices.getMainQuestionnary(3)
    }

    if (this.calificationConfig.colorPalette.isActive) {
      this.degrade = this.generateColor()
    }

    this.rating = this.calificationConfig.initialRating
  }

  toggleButton () {
    this.button.calificate.loading = !this.button.calificate.loading
    this.button.calificate.disabled = !this.button.calificate.disabled
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }

  ocGoogleAnalyticsContinue () {
    OcGoogleAnalytics.getDataLayerConfig('continue')
  }

  ocGoogleAnalytics () {
    OcGoogleAnalytics.getDataLayerConfig('analytics')
    return 'Success'
  }

  async calificate (calificate) {
    this.ocGoogleAnalyticsContinue()
    this.ocGoogleAnalytics()
    this.toggleButton()

    if (!calificate) {
      this.rating = null
    }

    const sessionId = this.$store.state.storage.room.session.id

    if (!sessionId) {
      this.toggleButton()
      return
    }

    const data = {
      route: `ocular/widget/session/${sessionId}/calificate`,
      params: {
        rating: this.rating,
        comment: this.comment,
        recommend: this.recommend
      }
    }

    MainService.post(data)
      .then(() => {
        this.$router.replace({ path: '/thank-you-page', query: { goodBye: true } })
      })
      .catch((e) => {
        console.log(e)
      })
      .finally(() => {
        this.toggleButton()
      })
  }
}
</script>

<style>
  .slider {
    display: flex;
    overflow-x: auto;
    padding: 10px;
    align-items: center;
    justify-content: space-around;
    align-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }

  .text-box {
    width: 100px;
    border:1px solid 0cap;
    background-color: #f0f0f0;
    border-radius: 5px;
    padding: 10px;
    margin: 0 .3px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .text-box.text--white span {
    color:white !important;
  }


</style>